import uniqid from 'uniqid';
import moment from 'moment';

const DAY_NAME = ['일', '월', '화', '수', '목', '금', '토'];

//TO-DO 카트는 vuex로 할 필요 없을듯 함, API 만들고 CART_LIST로 옮기면 제거
const state = { cartItems: [] };

const mutations = {
  UPDATE_CART_ITEMS(state, payload) {
    state.cartItems = payload.items;
  },
  UPDATE_CART_ITEM_CHECKED(state, payload) {
    const { targets = [], value } = payload;
    targets.forEach((e) => {
      e.checked = value;
    });
  },
};

const actions = {
  getCartItems({ commit, rootState }, groupPersDiv) {
    const id = rootState.ui?.hpUserId;
    const cart = localStorage.getItem('cart' + '_' + id + '_' + groupPersDiv);
    const data = cart ? JSON.parse(cart) : [];
    const today = moment().format('YYYY-MM-DD');
    const today1 = new Date();
    const today2 = new Date();
    today2.setHours(14,20,0,0);

    const filteredItems = data.filter((e) => {
  
      //어체 & 오후 2시 20분 이전
      if (today2 >= today1 && e.mrktnPdNo === 674) {
          return e.expVisitRvdt >= today;
      //그 외
      } else {
        return e.expVisitRvdt > today;
      }
      });
      //const filteredItems = data.filter((e) => (e.expVisitRvdt > today && e.mrktnPdNo !== 674) || (e.expVisitRvdt >= today && e.mrktnPdNo === 674 && today2 >= today1));   

    filteredItems.forEach((e) => (e.checked = false));
    commit('UPDATE_CART_ITEMS', { items: filteredItems });
  },
  addCartItem({ commit, state, rootState, getters }, { cartItem, replace }) {
    return new Promise((resolve, reject) => {
      const id = rootState.ui?.hpUserId;
      let newCartItem = { ...cartItem };
      const groupPersDiv = newCartItem.groupPersDiv;
      if (groupPersDiv) {
        const localKey = 'cart' + '_' + id + '_' + groupPersDiv;
        const cart = localStorage.getItem(localKey);
        const data = cart ? JSON.parse(cart) : [];
        if (!cartItem.id) {
          newCartItem.id = parseInt(Math.random() * 10000);
        }

        const duplIdx = data.findIndex(
          (e) => e.mrktnPdNo === newCartItem.mrktnPdNo && e.expVisitRvdt === newCartItem.expVisitRvdt && e.mrktnScheSeqNo === newCartItem.mrktnScheSeqNo,
        );

        //중복이 없거나 replace가 true면
        if (duplIdx < 0 || replace) {
          if (duplIdx > -1) {
            data.splice(duplIdx, 1);
          }
          const savedCartItems = [...data, newCartItem];
          localStorage.setItem(localKey, JSON.stringify(savedCartItems));
          commit('UPDATE_CART_ITEMS', { items: savedCartItems });
          resolve(true);
        } else {
          //중복이 있고 replace가 false면
          customConfirm('동일한 체험상품(체험일, 회차)이 체험바구니에 있습니다. 대체하시겠습니까?', (confirm) => {
            if (confirm) {
              data.splice(duplIdx, 1);
              const savedCartItems = [...data, newCartItem];
              localStorage.setItem(localKey, JSON.stringify(savedCartItems));
              commit('UPDATE_CART_ITEMS', { items: savedCartItems });
              resolve(true);
            } else {
              resolve(false);
            }
          });
        }
      }
    });
  },
  removeCartItem({ commit, state, rootState }, groupPersDiv) {
    const id = rootState.ui?.hpUserId;
    const newCartItems = state.cartItems.filter((e) => !e.checked);
    localStorage.setItem('cart' + '_' + id + '_' + groupPersDiv, JSON.stringify(newCartItems));
    commit('UPDATE_CART_ITEMS', { items: newCartItems });
  },
  removeAllCartItems({ commit, rootState }, groupPersDiv) {
    const id = rootState.ui?.hpUserId;
    localStorage.setItem('cart' + '_' + id + '_' + groupPersDiv, JSON.stringify([]));
    commit('UPDATE_CART_ITEMS', { items: [] });
  },
  changeItemCheck({ commit, getters }, { target, value }) {
    const item = getters.groupItems.find((gi) => gi.key === target);
    commit('UPDATE_CART_ITEM_CHECKED', { targets: item.items, value });
    //removeItems.items = removeItems.items.map((i) => ({ ...i, checked: false }));
  },
};

const getters = {
  cartItems: (state) => state.cartItems,
  checkedItems(state) {
    return state.cartItems.filter((e) => e.checked);
  },
  groupItems: (state) => {
    const expVisitGroups = {};
    state.cartItems.forEach((e) => {
      if (expVisitGroups[e.expVisitRvdt]) {
        expVisitGroups[e.expVisitRvdt].items.push(e);
      } else {
        expVisitGroups[e.expVisitRvdt] = {
          key: uniqid(),
          expVisitRvdt: e.expVisitRvdt,
          expVisitNm: e.expVisitRvdt + ' (' + DAY_NAME[moment(e.expVisitRvdt, 'YYYY-MM-DD').day()] + ')',
          items: [e],
        };
      }
    });

    return Object.values(expVisitGroups).sort((a, b) => (a.expVisitRvdt < b.expVisitRvdt ? -1 : 1));
  },
  cartTotal: (state) => {
    const total = 0;
    // const total = state.cartItems.reduce((totalPrice, cartItem) => {
    //   totalPrice = cartItem.customer.reduce((acc, cus) => {
    //     return cus.price * cus.count + acc;
    //   }, totalPrice);
    //   totalPrice = cartItem.guardian.reduce((acc, guardian) => {
    //     return guardian.price * guardian.count + acc;
    //   }, totalPrice);
    //   return totalPrice;
    // }, 0);
    return total;
    // return state.cartItems
    //   .reduce((acc, cartItem) => {
    //     return cartItem.quantity * cartItem.price + acc;
    //   }, 0)
    //   .toFixed(2);
  },
  cartQuantity: (state) => {
    return state.cartItems.length;
    // return state.cartItems.reduce((acc, cartItem) => {
    //   return cartItem.quantity + acc;
    // }, 0);
  },
  usedCouponList(state, getter) {
    const coupons = getter.cartItems?.filter((e) => e.couponsaleSeq > 0).map((e) => e.couponsaleSeq);
    return coupons;
  },
};

const cartModule = { state, mutations, actions, getters };

export default cartModule;
